'use strict';

import Loader from '../../../_modules/loader/loader';

import { isFieldEmpty, displayErrors, debounce } from './_helper';
import { toaster } from './_material';

let $dashboardCustService = $('#institution-hcp-details'),
	$selectInstitutionHcpDropdown = $('.select-institution-hcp__dropdown'),
	$InstitutionSelect = $('#InstitutionDropdown'),
	$HcpSelect = $('#HcpDropdown'),
        $CreateRegimenForClientHcpSelect = $('#CreateRegimenForClientHcpDropdown'),
	$formBtnWrapper = $('.form--institution-hcp-details__btn'),
	$formBtn = $('.js-set-institution-hcp-details'),
	$createRegimenForClientFormBtn = $('.js-set-hcp-details-create-regimen'),
	$suggestions = $('.form--suggestions-institutions'),
    $institutionId = $('#hiddenInstitutionId'),
    $clientId = $('#ClientId'),
	loader = new Loader(),
	_data = [],
	_isInvalid = [],
	formSuggestionHtml  = '',
	formSuggestionTmp = '',
    $selectHcpDropdown = $('.create-regimen-select-hcp__dropdown'),
    $createRegimenButtonOnViewClientPage = $('.js-cust-service-create-regimen');

$(() => {
    if (!$dashboardCustService.length && !$createRegimenButtonOnViewClientPage.length) {
        return false;
    }

    $('.js-cust-service-create-regimen').on('click', function(e) {
        e.preventDefault();
        $selectHcpDropdown.find('#HcpDropdown').fadeIn();
        $selectHcpDropdown.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false,
            complete: function () {
                $('body').addClass('fixed');
            }
        });
    });

    $('.js-dashboard-cust-service').on('click', function (e){
    	e.preventDefault();

    	$selectInstitutionHcpDropdown.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false,
            complete: function () {
                $('body').addClass('fixed');
            }
        });
    });

    // render doT template only if needed
    if($('#institution-suggestion-tmp').length){
        //To display list of Institutions
        formSuggestionTmp = doT.template($('#institution-suggestion-tmp').html());
    }

    $InstitutionSelect.on('keyup', debounce(function(){

    	let $this = $(this),
    		$errorContainer = $(this).parent().siblings('.server-errors__wrap'),
    		dataParams = {'name': $this.val()},
    		obj = {},
    		formSuggestionHtml = '';
    	loader.fadeIn();

    	var encodedParams = jQuery.param(dataParams);
    	$.ajax({
	        url: '/api/institutions?'+encodedParams,
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
            headers: { __RequestVerificationToken: $selectInstitutionHcpDropdown.find('input[name=__RequestVerificationToken').val() },
	        type: 'GET',
	        success: function (data) {

	        	$suggestions.addClass('active');

	        	if (!data.length) {
					//Fade in/out loader, display no results
					loader.fadeOut();
					toaster('No results found.', 'error');
	                $suggestions.removeClass('active');
	                return false;
	            }

	            for (let i = 0, l = data.length; i < l; i++) {
	                obj = {
	                    "id": data[i].InstitutionId,
	                    "name": data[i].InstitutionName
	                };

	                formSuggestionHtml += formSuggestionTmp(obj);
	            }

	            $('.form--institution-suggested').html(formSuggestionHtml);

	        	loader.fadeOut();

	            $errorContainer.slideUp({
	                duration: 500,
	                easing: 'easeInOutExpo',
	                queue: false
	            });
	        },
	        error: function (error) {
	            loader.fadeOut();
	            displayErrors(error, $errorContainer );
	        }
	    });

    }, 250));


    $('body').on('click', '.js-populate-hcp', function (e) {

    	let $this = $(this),
    		$errorContainer = $(this).parent().siblings('.server-errors__wrap'),
    		selectedInstitution = $this.data('name'),
    		dataParams = {'institutionId': $this.data('index')};
        $institutionId.val($this.data('index'));
    	$suggestions.removeClass('active');

    	$InstitutionSelect.val(selectedInstitution);

    	loader.fadeIn();

    	var encodedParams = jQuery.param(dataParams);
    	$.ajax({
            // url: '/api/hcpworkplaces2?'+encodedParams, //proto
	        url: '/api/hcpworkplaces?'+encodedParams,
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
	        type: 'GET',
	        success: function (data) {
	        	//to populate HCP dropdown
                $HcpSelect.find('option').not(':first').remove();

                $.each(data, function(index, item){
	        		$HcpSelect.append(
	        			$('<option></option>')
	        				.text(item.Name)
	        				.val(item.HcpWorkplaceId)
	        		);
	        	});

	        	loader.fadeOut();

	            $errorContainer.slideUp({
	                duration: 500,
	                easing: 'easeInOutExpo',
	                queue: false
	            });

	            $HcpSelect.fadeIn();
	        },
	        error: function (error) {
	            loader.fadeOut();
	            displayErrors(error, $errorContainer );
	        }
	    });

    });

    // to display continue btn
    $HcpSelect.on('change', function (e){
    	e.preventDefault();

    	$formBtnWrapper.fadeIn();
    });

    $CreateRegimenForClientHcpSelect.on('change', function (e){
    	e.preventDefault();

    	$formBtnWrapper.fadeIn();
    });

    //to redirect to dashboard (if customer service)
    $createRegimenForClientFormBtn.on('click', function(){
        _isInvalid = [];

        if(isFieldEmpty($CreateRegimenForClientHcpSelect)){
            $CreateRegimenForClientHcpSelect
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {

            _isInvalid = [];

            $(this).removeClass('error');

            loader.fadeIn();

            var institutionId = 'institutionId=' + $institutionId.val();
            var hcpWorkplaceId = '&hcpWorkplaceId=' + $CreateRegimenForClientHcpSelect.val();
            var clientId = '&clientId=' + $clientId.val();

            var createRegimenUrl = $formBtn.data('url') + '?' + institutionId + hcpWorkplaceId + clientId;

            if (!$createRegimenButtonOnViewClientPage.length === 0){
                createRegimenUrl += '&clientId=' +$createRegimenButtonOnViewClientPage.data('client-id');
            }

            location.href = createRegimenUrl;
        }

    });

    //to redirect to dashboard (if customer service)
    $formBtn.on('click', function(){
    	_isInvalid = [];

    	if($InstitutionSelect.length && $InstitutionSelect.val() === ''){
    		$InstitutionSelect
    			.parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
    	}

    	if(isFieldEmpty($HcpSelect)){
    		$HcpSelect
    			.parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
    	}

    	if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {

            _isInvalid = [];

            $(this).removeClass('error');

            loader.fadeIn();

            var createRegimenUrl = $formBtn.data('url') + '?institutionId=' + $institutionId.val() + '&hcpWorkplaceId=' + $HcpSelect.val();
            if (!$createRegimenButtonOnViewClientPage.length === 0){
                createRegimenUrl += '&clientId=' +$createRegimenButtonOnViewClientPage.data('client-id');
            }

            location.href = createRegimenUrl;
        }

    });

});
